import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BiChevronRight } from 'react-icons/bi';
import { applyBreadcrumbLeaf, buildBreadcrumbTrail } from './breadcrumbTrail';
import { useBreadcrumbLeaf } from './breadcrumbLeaf';

const WorkspaceBreadcrumb = () => {
  const { pathname, search } = useLocation();
  const leaf = useBreadcrumbLeaf();
  const crumbs = useMemo(() => {
    const title = leaf.path === pathname ? leaf.label : '';
    const base = applyBreadcrumbLeaf(buildBreadcrumbTrail(pathname), title);
    const reportOpen = /\/reports$/.test(pathname) && new URLSearchParams(search).has('report');
    if (!reportOpen || !title || title === 'Reports') return base;
    return [...base, { label: title, to: `${pathname}${search}` }];
  }, [pathname, search, leaf]);

  if (pathname === '/workspace' || crumbs.length === 0) return null;

  return (
    <nav className="ws-crumbs" aria-label="Breadcrumb">
      <ol className="ws-crumbs__list">
        {crumbs.map((crumb, index) => {
          const current = index === crumbs.length - 1;
          return (
            <li key={`${crumb.to}-${crumb.label}`} className="ws-crumbs__item">
              {index > 0 ? (
                <BiChevronRight className="ws-crumbs__sep" aria-hidden />
              ) : (
                <span className="ws-crumbs__mark" aria-hidden />
              )}
              {current ? (
                <span className="ws-crumbs__current" aria-current="page" title={crumb.label}>
                  {crumb.label}
                </span>
              ) : (
                <Link className="ws-crumbs__link" to={crumb.to}>
                  {crumb.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default WorkspaceBreadcrumb;
